import React from "react";
import sasikumarBW from "../assets/sasikumar.png";
import sasikumarColor from "../assets/sasikumar-color.webp";
// import sasikumarBG from "../assets/sasikumar-bg.png";
import madanBW from "../assets/madan.png";
import madanColor from "../assets/madan-color.png";
// import madanBG from "../assets/madan-bg.png";
import karthikBW from "../assets/Karthikk.png";
import karthikColor from "../assets/karthik-color.webp";
import mohanBW from "../assets/mohan.png";
import mohanColor from "../assets/mohan-color.webp";
// import mohanBG from "../assets/mohan-bg.png";
import raguBW from "../assets/Ragu.png";
import raguColor from "../assets/Ragu-colorrr.webp";
import emojiLaugh from "../assets/emoji1.svg"; // 😂 emoji
import emojiStar from "../assets/emoji2.svg"; // 🤩 emoji
import paperPlane from '../assets/paper-planee.svg'; // Adjust if path differs
import contactStrip from "../assets/strip-images.webp"; // Assume this is an array of image imports
import peopleImage from "../assets/people-lentera.webp";
import yellowDot from "../assets/decor-yellow-dott.svg";
import pinkTriangle from "../assets/decor-pink-trianglee.svg";

import underline from "../assets/underlinea.png";
import { useEffect, useState ,useRef} from 'react';

import { useNavigate } from 'react-router-dom'; 
 
const PeopleSection = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
        // const [isServicesOpen, setIsServicesOpen] = useState(false);
        // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
        // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
      
        const toggleMobileMenu = () => {
          setIsMobileMenuOpen(!isMobileMenuOpen);
        };
      
        // const toggleServicesDropdown = () => {
        //   setIsServicesOpen(!isServicesOpen);
        // };
      
        // const toggleIndustriesDropdown = () => {
        //   setIsIndustriesOpen(!isIndustriesOpen);
        // };
      
        // const toggleCompanyDropdown = () => {
        //   setIsCompanyOpen(!isCompanyOpen);
        // };
  
    const [openDropdown, setOpenDropdown] = useState(null);
    const navRef = useRef(null);
  
    // Close dropdown on outside click
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (navRef.current && !navRef.current.contains(event.target)) {
          setOpenDropdown(null);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
  
    const toggleDropdown = (dropdown) => {
      setOpenDropdown(openDropdown === dropdown ? null : dropdown);
    };
    
    const navigate = useNavigate();
   
    const handleClick = () => {
      navigate("/Contact#contact-section");
    };
      const [isOpen, setIsOpen] = useState(false);
            
              // const toggleDropdown = () => {
              //   setIsOpen((prev) => !prev);
              // };
        
        
              const [isServicesOpen, setIsServicesOpen] = useState(false);
          const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
          const [isCompanyOpen, setIsCompanyOpen] = useState(false);
        
          // Toggle functions for dropdowns
          const toggleServicesDropdown = () => {
            setIsServicesOpen(!isServicesOpen);
            setIsIndustriesOpen(false);
            setIsCompanyOpen(false); // Close other dropdowns
          };
        
          const toggleIndustriesDropdown = () => {
            setIsIndustriesOpen(!isIndustriesOpen);
            setIsServicesOpen(false);
            setIsCompanyOpen(false); // Close other dropdowns
          };
        
          const toggleCompanyDropdown = () => {
            setIsCompanyOpen(!isCompanyOpen);
            setIsServicesOpen(false);
            setIsIndustriesOpen(false); // Close other dropdowns
          };
              const [word, setWord] = useState('Today');
        
          useEffect(() => {
            const interval = setInterval(() => {
              setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
            }, 2000);
            return () => clearInterval(interval);
          }, []);
      
   
  const team = [
  {
    name: "Sasikumar S",
    title: "Founder & CEO",
    bwImage: sasikumarBW,
    colorImage: sasikumarColor,
    quote: "When you grow, we succeed your progress fuels our purpose",
  },
  {
    name: "Madan Kumar B",
    title: "Chief Technology Officer",
    bwImage: madanBW,
    colorImage: madanColor,
    quote: "Your progress inspires our passion to serve better",
  },
  {
    name: "Mohan Kumar S",
    title: "Customer Sales & Delivery Head",
    bwImage: mohanBW,
    colorImage: mohanColor,
    quote: "Don’t limit your challenges.Challenge your limits.",
  },
  {
    name: "Ragu Ram",
    title: "Research & Development Head",
    bwImage: raguBW,
    colorImage: raguColor,
    quote: "Action is the foundational key to all success",
  },
  {
    name: "Karthikeyan M",
    title: "IT Head",
    bwImage: karthikBW,
    colorImage: karthikColor,
    quote: "Never wait for your opportunity.Create your own.",
  },
];

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
  return (

    
    <>
    
<section className="w-full bg-[#fdf6dc] font-poppins pb-24">
  {/* Header */}
  <div className="text-center px-4 pt-20">
    <h2 className="text-[40px] sm:text-[48px] font-semibold text-[#1E1E1E] leading-tight">
      People of Lentera
    </h2>
    <img
      src={underline}
      alt="underline"
      className="mx-auto mt-2 w-[80px] h-[2px]"
    />
    {/* <div className="w-[72px] h-[2px]  bg-green-600 center mb-6" /> */}
    <p className="mt-6 text-base sm:text-lg text-[#3A3A3A] max-w-[700px] mx-auto leading-relaxed">
      A behind-the-scenes look at the people who shaped our craft— building the foundation of our culture and the products we proudly create today.
    </p>
  </div>

  {/* Team Cards */}
  <div className="mt-24 space-y-12 px-4">
    {/* Row 1 */}
    <div className="flex justify-center gap-8 flex-wrap">
      {team.slice(0, 3).map((member, index) => (
        <div
          key={index}
          className="group w-[320px] h-[320px] bg-white rounded-[14.62px] border border-[#E0E0E0] text-center shadow-sm relative"
        >
          {/* Image Box */}
          <div
            className="absolute -top-[10px] left-1/2 transform -translate-x-1/2 z-30 rounded-[14.62px] flex items-center justify-center overflow-hidden"
            style={{ width: '277.85px', height: '228.49px' }}
          >
            <img
              src={member.bwImage}
              alt={member.name}
              className="w-full h-full object-contain absolute top-0 left-0 transition-opacity duration-300 group-hover:opacity-0"
            />
            <img
              src={member.colorImage}
              alt={`${member.name} Color`}
              className="w-full h-full object-contain absolute top-0 left-0 opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:scale-105"
            />
          </div>

          {/* Text Content */}
          <div className="absolute bottom-6 left-0 w-full px-4">
            <div className="group-hover:hidden transition-opacity">
              <h3 className="text-[18px] font-semibold text-[#1E1E1E]">{member.name}</h3>
              <p className="text-sm text-[#6B6B6B] mt-1">{member.title}</p>
            </div>
            <div className="hidden group-hover:block">
              <p className="text-sm text-[#1E1E1E] italic leading-snug">“{member.quote}”</p>
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* Row 2 */}
    
    <div className="flex justify-center gap-8 flex-wrap">
      {team.slice(3, 5).map((member, index) => (
        <div
          key={index}
          className="group w-[314px] h-[320px] bg-white rounded-[14.62px] border border-[#E0E0E0] text-center shadow-sm relative"
        >
          {/* Image Box */}
          <div
            className="absolute -top-[20px] left-1/2 transform -translate-x-1/2 z-30 rounded-[14.62px] flex items-center justify-center overflow-hidden"
            style={{ width: '280.85px', height: '238.49px' }}
          >
            <img
              src={member.bwImage}
              alt={member.name}
              className="w-full h-full object-contain absolute top-0 left-0 transition-opacity duration-300 group-hover:opacity-0"
            />
            <img
              src={member.colorImage}
              alt={`${member.name} Color`}
              className="w-full h-full object-contain absolute top-0 left-0 opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:scale-105"
            />
          </div>

          {/* Text Content */}
          <div className="absolute bottom-6 left-0 w-full px-4">
            <div className="group-hover:hidden transition-opacity">
              <h3 className="text-[18px] font-semibold text-[#1E1E1E]">{member.name}</h3>
              <p className="text-sm text-[#6B6B6B] mt-1">{member.title}</p>
            </div>
            <div className="hidden group-hover:block">
              <p className="text-sm text-[#1E1E1E] italic leading-snug">“{member.quote}”</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>




 


        <section className="w-full bg-white py-20 px-4 lg:px-16 font-poppins">
      <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row items-start gap-12 relative">
        
        {/* Left Side (40%) */}
        <div className="w-full md:w-[40%] min-h-[505px] relative">
          
          {/* Emoji Laugh - Bottom Left of Heading */}
          <img 
            src={emojiLaugh} 
            alt="Laugh Emoji" 
            className="absolute top-0 left-0 w-12 h-12 md:w-14 md:h-14" 
          />

          {/* Emoji Star - Floating above right side of heading */}
          <img 
            src={emojiStar} 
            alt="Star Emoji" 
            className="absolute top-[0px] right-[30px] w-20 h-20 md:w-20 md:h-20" 
          />

          {/* Heading and Content */}
          <div className="mt-16">
            <h2 className="text-[48px] font-normal text-[#1A1A1A] leading-[52px] mb-6">
  Passionate work,<br /> playful connections
</h2>


            {/* Green underline */}
            <div className="w-[72px] h-[2px] bg-green-600 mb-6" />

            {/* Description */}
           <p className="text-[#4B4B4B] text-[16px] font-normal leading-[30px] tracking-tight mb-8">
  At Lentera Technologies, we empower like-minded individuals with the freedom to thrive. With the right tools and support, your growth becomes our shared success.
</p>


            {/* Paper plane */}
            <img 
              src={paperPlane} 
              alt="Paper Plane" 
              className="w-80 h-40 mt-4 ml-1"
            />
          </div>
        </div>
       

        {/* Right Side (60%) - Scrolling Strip */}
        <div className="relative w-[768px] h-[505px] overflow-hidden rounded-md">
          {/* Blur overlays */}
          <div className="absolute top-0 left-0 w-20 h-full z-10 bg-gradient-to-r from-white via-white/80 to-transparent pointer-events-none" />
          <div className="absolute top-0 right-0 w-20 h-full z-10 bg-gradient-to-l from-white via-white/80 to-transparent pointer-events-none" />

          {/* Scrolling strip */}
          <div className="flex w-max animate-scroll-seamless whitespace-nowrap">
            {[...Array(4)].map((_, i) => (
              <img
                key={i}
                src={contactStrip}
                alt={`contact-strip-${i}`}
                className="h-[505px] w-[768px] object-cover shrink-0"
              />
            ))}
          </div>

          {/* Scroll Animation */}
          <style>{`
            @keyframes scroll-seamless {
              0% {
                transform: translateX(0%);
              }
              100% {
                transform: translateX(-50%);
              }
            }
            .animate-scroll-seamless {
              animation: scroll-seamless 20s linear infinite;
            }
          `}</style>
        </div>
      </div>
    </section>
     <section className="w-full bg-white font-poppins relative overflow-hidden pb-24">
  {/* Top Team Image */}
  <img
    src={peopleImage}
    alt="People of Lentera"
    className="w-full object-cover h-auto max-h-[600px]"
  />

  {/* Content Card */}
  <div className="w-full flex justify-center -mt-20 px-4 relative z-10">
    <div className="bg-white -[16px] shadow-xl w-full max-w-[1312px] px-6 md:px-[64px] lg:px-[84px] py-[56px] flex flex-col md:flex-row items-start justify-between relative">
      
      {/* Yellow Dot */}
      <img
        src={yellowDot}
        alt="Yellow Dot"
        className="absolute top-0 left-0 w-[60px] md:w-[76px] h-auto"
      />

      {/* Pink Triangle */}
      <img
        src={pinkTriangle}
        alt="Pink Triangle"
        className="absolute right-0 bottom-0 w-[100px] md:w-[125px] h-auto"
      />

      {/* Paper Plane */}
      <img
        src={paperPlane}
        alt="Paper Plane"
        className="absolute hidden sm:block left-[0%] md:left-[300px] bottom-[-10px] w-[200px] md:w-[300px] h-auto"
      />

      {/* Left Side */}
      <div className="w-full md:w-[440px] mb-8 md:mb-0">
        <h2 className="text-[40px] md:text-[48px] leading-[46px] md:leading-[52px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#7B41E6] to-[#ED72EF]">
          6+ years
        </h2>
        <p className="text-[18px] md:text-[20px] leading-[28px] md:leading-[32px] text-[#212129] font-medium mt-2">
          of running a business has taught us many things
        </p>
      </div>

      {/* Right Side: Quote */}
      <div className="w-full md:w-[580px]">
        <div className="border-l-[2px] border-[#07862B] pl-6 italic text-[16px] md:text-[18px] text-[#333] leading-[28px] md:leading-[30px]">
          “We believe that investing in our people leads to long-term
          commitment. We're proud and humbled that many of our colleagues
          have been with us for over a decade, growing alongside the
          company.”
        </div>
      </div>
    </div>
  </div>
</section>

    </>
    
  );
};

export default PeopleSection;
